// aktionsKnopfStil.ts — Optik der Aktionsknöpfe rechts neben Telefon/E-Mail
// (Anrufen, Mail schreiben). Früher inline an einem <button>; seit die
// Knöpfe AnsichtsKnöpfe sind (<span role="button">), hier gebündelt.

import type * as React from "react";

export const aktionsKnopfStil = (aktiv: boolean): React.CSSProperties => ({
  boxSizing: "border-box",
  height: "100%",
  minHeight: "42px",
  width: "42px",
  background: "none",
  border: "1px solid #d1c7bd",
  borderRadius: "10px",
  padding: "0",
  cursor: aktiv ? "pointer" : "not-allowed",
  color: aktiv ? "#3a0c31" : "#8a7d88",
  opacity: aktiv ? 1 : 0.35,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.15s ease",
  flexShrink: 0,
});
